<template>
  <div>
    <b-carousel
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000"
      fade
      indicators
      img-width="1024"
      img-height="480"
    >
        <b-carousel-slide
        :caption-html="mensaje1.titulo"
        captionTag="H1"
        img-src="../assets/images/4.jpg"
        :text="mensaje1.mensaje"
      ></b-carousel-slide>
     <b-carousel-slide
        :caption-html="mensaje2.titulo"
        captionTag="H2"
        img-src="../assets/images/1.jpg"
        :text="mensaje2.mensaje"
      ></b-carousel-slide>
      <b-carousel-slide
        :caption-html="mensaje3.titulo"
        captionTag="H2"
        img-src="../assets/images/3.jpg"
        :text="mensaje3.mensaje"
      ></b-carousel-slide>
      <!-- <b-carousel-slide
       :caption-html="mensaje4.titulo"
        captionTag="H3"
        img-src="../assets/images/8.jpg"
        :text="mensaje4.mensaje"
      ></b-carousel-slide> -->
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "carrusel",
  components: {},
  data() {
    return {
      mensaje1: {
        titulo: "<p style='font-size:120%'>Simplicidad</p>",
        mensaje: "Soluciones simples... pero efectivas",
      },
      mensaje2: {
        titulo: "<p style='font-size:120%; color:white'>Enfoque</p>",
        mensaje: "No pienses en tu software... piensa en tus clientes",
      },
      mensaje3: {
        titulo: "<p style='font-size:120%; color:white'>Soluciones</p>",
        mensaje: "Para que no te olvides de lo más importante",
      },
      mensaje4: {
        titulo: "<p style='font-size:120%;text-align:right'>Facilidad</p>",
        mensaje: "Lo facilitamos para Ti",
      },
    };
  },
};
</script>

<style>
div.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 15%;
  left: 5%;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 60%;
  letter-spacing: 0.007em;
  font-family: "SF Pro Display", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
  line-height: 1.14286;
}

p {
  color: #122130;
  text-align: left;
  font-size: 25px;
  font-weight: 600;
  text-shadow: #ffffff 0px 0px 1px;
}

h2 + p {
  color: #ffffff;
}

h3, h3 + p {
  text-align: right;
}

</style>
